import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react"; // You can use any icon library

const EmailConfirmation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/exam-selection");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-[87vh] bg-gradient-to-br from-teal-400 to-purple-300 px-4">
      <div className="bg-white p-6 md:p-10 rounded-2xl shadow-xl text-center max-w-md w-full">
        <CheckCircle className="mx-auto text-green-500 w-12 h-12 mb-3" />
        <h1 className="text-2xl font-bold text-teal-600 mb-2">Submission Successful!</h1>
        <p className="text-gray-700 text-md mb-3">
          We've sent your scores to your email. Check your inbox!
        </p>
        {/* <p className="text-sm text-gray-500 mb-4">Redirecting in 5 seconds...</p> */}

        {/* Animated progress bar */}
        <div className="relative h-2 w-full bg-gray-200 rounded-full overflow-hidden">
          <div className="absolute left-0 top-0 h-full bg-orange-500 animate-progressBar w-full"></div>
        </div>
      </div>

      {/* Animation CSS */}
      <style>{`
        @keyframes loading {
          from { transform: translateX(-100%) }
          to { transform: translateX(0%) }
        }
        .animate-progressBar {
          animation: loading 5s linear forwards;
        }
      `}</style>
    </div>
  );
};

export default EmailConfirmation;
